import {useEffect} from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

import store from "../../../store";
import {setWizardActiveStep} from "../../../actions/wizardFunctions";
import {useIsMounted} from "../../../misc/helperHooks";

let historyTimeoutId = null;

const MaterialsWizardHistoryListener = (props) => {

  const {location, history, match, setWizardActiveStep, children} = props;

  const isMounted = useIsMounted();

  useEffect(() => {
    historyTimeoutId = setTimeout(() => {
      if (!isMounted() || !location || !location.pathname) {
        return
      }
      // console.log("useEffect location.pathname", location.pathname);
      const currentStore = store.getState();
      const {subPartName} = match.params;
      const {wizardActiveStep, wizardSelectedValues} = currentStore.wizardState; // we need to detect current values
      // console.log("subPartName", subPartName);
      // console.log("wizardActiveStep", wizardActiveStep);
      if (!location.pathname.includes("materials")) {
        return;
      }
      if (!subPartName || !Number.isInteger(+subPartName) && wizardActiveStep > 0) {
        // console.log("seeeeeeeeeet 0", );

        setWizardActiveStep(0); // cases when someone goes to /materials
        return;
      }

      const stepFromUrl = subPartName - 1; // because we don't want to have 0 in the URL
      // console.log("stepFromUrl", stepFromUrl);
      if (wizardActiveStep !== stepFromUrl) {
        // console.log("seeeeeeeeeet idFromUrl", );
        if (wizardSelectedValues[stepFromUrl - 1]) { // if previous step is selected - it's ok, we can go to the next step
          setWizardActiveStep(stepFromUrl)
        } else { // this is when we go directly to materials/cabinets/3/upper-cabinet-boxes but they are not selected yet
          setWizardActiveStep(0)
          history.push("/materials");
        }
      }
    }, 0)
    return () => {
      clearTimeout(historyTimeoutId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return children
}

const mapDispatchToProps = {
  setWizardActiveStep,
}

export default withRouter(
  connect(null, mapDispatchToProps)(MaterialsWizardHistoryListener)
)

